// SesameButton.jsx
import { sesame } from "../utils/functions";

const SesameButton = ({ name, setRa, setDec }) => {
  const handleClick = async () => {
    const trimmedName = name.trim();

    if (!trimmedName) {
      alert("Por favor ingresa un nombre.");
      return;
    }

    try {
      const result = await sesame(trimmedName);

      if (result && result.ra !== undefined && result.dec !== undefined) {
        // Actualiza el estado de AddTarget
        setRa(result.ra);
        setDec(result.dec);
      } else {
        alert("No se obtuvieron coordenadas válidas.");
      }
    } catch (error) {
      console.error("Error al obtener datos de Sesame:", error);
      alert("Ocurrió un error al consultar Sesame.");
    }
  };

  return (
    <button
      title="Sesame name solver (or write coordinates manually"
      type="button"
      onClick={handleClick}
      className="px-4 py-2 text-white "
    >
      Solve <i class="bi bi-box-arrow-in-right"></i>
    </button>
  );
};

export default SesameButton;
